import { useEffect } from 'react'
import { useLoadScript } from '@react-google-maps/api'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../state/index'
import Map from './Map/index'
import { FromSitecorePropsType } from '../interfaces/index'
import { Icon } from 'utils'
import { ErrorOrLoading } from '../../../residential/shared'
import Legend from './Legend'
import { DEFAULT_ERROR_MESSAGE } from 'constant'
type Libraries = (
  | 'drawing'
  | 'geometry'
  | 'localContext'
  | 'places'
  | 'visualization'
)[]
const libraries: Libraries = ['drawing', 'geometry', 'places']

const App = (props: FromSitecorePropsType) => {
  const { isLoaded, loadError } = useLoadScript({
    // @ts-ignore
    libraries,
    googleMapsApiKey: props.mapApiKey
  })

  const { actions } = useStateMachine({ updateStore })
  useEffect(() => {
    actions.updateStore({
      ready: isLoaded,
      reportFormUrl: props.reportFormUrl,
      outagesFormUrl: props.outagesFormUrl
    })
    return () => {
      actions.updateStore({
        address: '',
        active: true,
        completed: true,
        registered: true,
        major: true,
        ready: false,
        markerData: [],
        features: [],
        markers: [],
        getAddress: void 0,
        map: void 0,
        reportFormUrl: void 0,
        outagesFormUrl: void 0
      })
    }
  }, [isLoaded])
  const PreMap = ({ outagesFormUrl, loading, error }: { outagesFormUrl: string; loading: boolean; error?: Error }) => {
    return (
      <div className="divide divide-grey-100 rounded-lg overflow-hidden" id="map-container">
        <div>
          <div className="wc-outages__search bg-ocean">
            <div className="flex-shrink">
              <label
                htmlFor="outage-map-ascx-address"
                className="wc-outages__sr-only"
              >
                Enter an address
              </label>

              <button className="wc-outages__search__button">
                <Icon
                  role="presentation"
                  width="32.5"
                  height="32.501"
                  fill="#fff"
                  id="#magnifier"
                />
                Search
              </button>
            </div>
            <input
              type="text"
              id="outage-map-ascx-address"
              name="address"
              className="wc-outages__input"
              placeholder="Enter an address"
              autoComplete="off"
            />
            <div className="flex-shrink">
              <a href={outagesFormUrl} className="wc-outages__warning__button">
                Sign up for water supply alerts
              </a>
            </div>

            <button className="wc-outages__filter__button" disabled={true}>
              <Icon
                role="presentation"
                width="32.182"
                height="30.654"
                fill="#fff"
                id="#filter"
              />
              Filter
            </button>
          </div>
          <div className="wc-outages__searchdrop wc-outages__searchdrop--hidden"></div>
        </div>
        <div className="wc-outages__container">
          <>
            <a
              href={outagesFormUrl}
              className="absolute top-10 right-10 z-10 hidden md:block btn-cta btn-mobile whitespace-normal"
            >
              Sign up for water supply alerts
            </a>

            <ErrorOrLoading
              loading={loading}
              error={(!!error && new Error(DEFAULT_ERROR_MESSAGE)) as Error}
            />
            <div className="wc-outages__map" />
          </>
        </div>
        <Legend />
      </div>
    )
  }

  return (
    <section>
      {isLoaded ? (
        <Map {...props} />
      ) : (
        <PreMap
          outagesFormUrl={props.outagesFormUrl}
          loading={!isLoaded && !loadError}
          error={loadError}
        />
      )}
    </section>
  )
}

export default App
